import { z } from 'zod';
import { CLASS_IDS } from '@prism/sim';

/**
 * Shared schema primitives (TRD-02 §4).
 *
 * R-02-05: ids are kebab-case and STABLE FOREVER. An id appearing in a stored replay must
 * resolve identically months later, so renaming one silently invalidates every daily
 * archived under it. Deprecate; never rename.
 */
export const KebabId = z
  .string()
  .min(2)
  .regex(/^[a-z][a-z0-9]*(-[a-z0-9]+)*$/, 'must be kebab-case (e.g. "splinter-lance")');

export const HexColor = z.string().regex(/^#[0-9a-f]{6}$/, 'must be lowercase #rrggbb');

export const ClassIdSchema = z.enum(CLASS_IDS);
export const DamageKindSchema = z.enum(['physical', 'magic', 'true']);
export const StatusKindSchema = z.enum([
  'poison',
  'chill',
  'shock',
  'wither',
  'mark',
  'stun',
  'freeze',
]);
export const TargetingModeSchema = z.enum(['first', 'last', 'closest', 'strongest', 'weakest']);
export const TierSchema = z.union([z.literal(1), z.literal(2), z.literal(3)]);
export const ThresholdSchema = z.union([z.literal(2), z.literal(4), z.literal(6)]);

export const TowerIdSchema = KebabId;
export const EnemyIdSchema = KebabId;
export const MapIdSchema = KebabId;
export const BiomeIdSchema = KebabId;
export const MutatorIdSchema = KebabId;

/** Map grid is fixed at 32×18 tiles of 16 px = 512×288 logical pixels (TRD-03 R-03-01). */
export const MAP_WIDTH = 32;
export const MAP_HEIGHT = 18;
export const MAP_TILES = MAP_WIDTH * MAP_HEIGHT;
